module.exports = __webpack_public_path__ + "static/media/woman.a94cdf8c.png";